export default __webpack_public_path__ + "static/media/contact-bg.051ce8db.png";